export default __webpack_public_path__ + "static/media/gitbook-icon-white.245e6e07.svg";